import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=433001d7&scoped=true"
import script from "./Header.js?vue&type=script&lang=js&external"
export * from "./Header.js?vue&type=script&lang=js&external"
import style0 from "./Header.scss?vue&type=style&index=0&id=433001d7&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433001d7",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotLink: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Link/Link.vue').default,HotButton: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Button/Button.vue').default})
